"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphPropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../base-utils/map-creator");
var paragraph_properties_1 = require("../../../../core/model/paragraph/paragraph-properties");
var list_1 = require("@devexpress/utils/lib/utils/list");
var string_1 = require("@devexpress/utils/lib/utils/map/string");
var property_destination_1 = require("../property-destination");
var inner_section_destination_1 = require("../section/inner-section-destination");
var paragraph_style_reference_destination_1 = require("../style/paragraph/paragraph-style-reference-destination");
var paragraph_numbering_reference_destination_1 = require("./paragraph-numbering-reference-destination");
var paragraph_properties_base_destination_1 = require("./paragraph-properties-base-destination");
var ParagraphPropertiesDestination = (function (_super) {
    tslib_1.__extends(ParagraphPropertiesDestination, _super);
    function ParagraphPropertiesDestination(data, paragraphDestination, paragraphProperties, tabs) {
        var _this = _super.call(this, data, paragraphProperties, tabs) || this;
        _this.paragraphDestination = paragraphDestination;
        data.subDocumentInfo.paragraphImporter.resetParMarkCharProperties()
            .resetParMarkCharacterStyle()
            .resetStyle();
        list_1.ListUtils.clear(tabs.tabsInfo);
        return _this;
    }
    Object.defineProperty(ParagraphPropertiesDestination.prototype, "listLevelIndex", {
        get: function () { return this.paragraphDestination.listLevelIndex; },
        set: function (value) { this.paragraphDestination.listLevelIndex = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParagraphPropertiesDestination.prototype, "numberingId", {
        get: function () { return this.paragraphDestination.numberingId; },
        set: function (value) { this.paragraphDestination.numberingId = value; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParagraphPropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return ParagraphPropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    ParagraphPropertiesDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    ParagraphPropertiesDestination.handlerTable = new map_creator_1.MapCreator(string_1.StringMapUtils.map(paragraph_properties_base_destination_1.ParagraphPropertiesBaseDestination.handlerTable, function (e) { return e; }))
        .add('pStyle', function (data) { return new paragraph_style_reference_destination_1.ParagraphStyleReferenceDestination(data); })
        .add('sectPr', function (data) {
        data.sectionImporter.shouldInsertSection = !data.subDocumentInfo.tableImporter.isInsideTable;
        return new inner_section_destination_1.InnerSectionDestination(data);
    })
        .add('numPr', function (data) { return new paragraph_numbering_reference_destination_1.ParagraphNumberingReferenceDestination(data, ParagraphPropertiesDestination.getThis(data)); })
        .add('divId', function (data) { return new property_destination_1.PropertyDestination(data, function (value) {
        var id = parseInt(value, 10);
        var webSettings = data.documentModel.webSettings;
        if (webSettings.id == id && webSettings.isBodyMarginsSet())
            ParagraphPropertiesDestination.getThis(data).paragraphProperties.setValue(paragraph_properties_1.ParagraphPropertyDescriptor.divId, id);
    }); })
        .get();
    return ParagraphPropertiesDestination;
}(paragraph_properties_base_destination_1.ParagraphPropertiesBaseDestination));
exports.ParagraphPropertiesDestination = ParagraphPropertiesDestination;
